/*
* 续保提醒线索
* */

import dayjs from 'dayjs';
import { vehicleInsuranceApis } from '@/api';

const clues = {
    name: 'clues',
    namespaced: true,
    state: {
        // 车辆信息
        vehicleInfo: {},
        // 关系人信息
        applicantsInfo: {},
        // 车险信息
        policyInfo: {},
        // 报价返回列表值
        quoteTableLists: [],
        // 报价提交参数
        quoteParams: {},
        // 保司配置信息（不区分主险副险）
        riskInfo: [],
        // 默认保司险别配置
        defaultRisk: {
            mRisk: [], // 主险
            sRisk: [], // 副险
        },
        // 指定保司险别配置
        riskConfig: {
            mRisk: [], // 主险
            sRisk: [], // 副险
        },
        // 已选中保司方案待核保信息
        quotedInfo: {},
        // 车险信息相关枚举值
        insuranceEnums: {},
        // 核保下单成功返回值
        insuranceOrder: {},
        // 核保下单影像上传成功图片
        insuranceImages: {},
        // 保单状态
        insuranceStatus: [
            {
                label: '下发修改',
                value: 'ISSUE_MODIFICATION',
                icon: 'icon_line_circle-wait',
            },
            {
                label: '人工审核',
                value: 'MANUAL_REVIEW',
                icon: 'icon_line_circle-wait',
            },
            {
                label: '核保成功',
                value: 'UNDERWRITING_SUCCESS',
                icon: 'icon_line_circle-sucess',
            },
            {
                label: '支付失败',
                value: 'PAYMENT_FAILED',
                icon: 'icon_line_circle-warning',
            },
            {
                label: '支付成功',
                value: 'PAYMENT_SUCCESS',
                icon: 'icon_line_circle-sucess',
            },
            {
                label: '承保失败',
                value: 'INSURANCE_FAILED',
                icon: 'icon_line_circle-warning',
            },
            {
                label: '承保成功',
                value: 'INSURANCE_SUCCESS',
                icon: 'icon_line_circle-sucess',
            },
            {
                label: '保司删除',
                value: 'INSURER_DELETED',
                icon: 'icon_line_circle-warning',
            },
            {
                label: '异常订单',
                value: 'ABNORMAL_ORDER',
                icon: 'icon_line_circle-warning',
            },
        ],
    },
    getters: {
        getCluesInfo: state => (key) => {
            if (key) {
                return state[key] || null;
            }

            return state;
        },
    },
    mutations: {
        INSURANCE_INFO: (state, data) => {
            const vehicle = data.vehicle || {};

            state.vehicleInfo = {
                ...vehicle,
                enrollDate: vehicle.enrollDate ? dayjs(vehicle.enrollDate).format('YYYY-MM-DD') : '',
                transferDate: vehicle.transferDate ? dayjs(vehicle.transferDate).format('YYYY-MM-DD') : '',
            };
            state.applicantsInfo = data.applicant || {};
            state.policyInfo = data.policy || {};
        },
        SAVE_QUOTE_LIST: (state, data) => {
            state.quoteTableLists = data.map((item) => {
                const mRisk = [];
                const sRisk = [];
                // 将主险和副险分离，便于列表展示使用
                (item.data.risks || []).forEach((v) => {
                    const mRiskInfo = state.defaultRisk.mRisk.find(t => t.code === v.code);
                    if (mRiskInfo) {
                        mRisk.push({
                            ...v,
                            field: mRiskInfo.field,
                        });
                    } else {
                        const sRiskInfo = state.defaultRisk.sRisk.find(t => t.code === v.code) || {};
                        sRisk.push({
                            ...v,
                            field: sRiskInfo.field,
                        });
                    }
                });
                return {
                    ...item.data,
                    code: item.code,
                    msg: item.msg,
                    mRisk,
                    sRisk,
                };
            });
        },
        CHANGE_QUOTE_INFO: (state, res) => {
            const { data, code, msg } = res;
            const mRisk = [];
            const sRisk = [];
            const oldInfo = [...state.quoteTableLists];
            const initMRisk = state.riskConfig.mRisk.length ? state.riskConfig.mRisk : state.defaultRisk.mRisk;
            const initSRisk = state.riskConfig.sRisk.length ? state.riskConfig.sRisk : state.defaultRisk.sRisk;
            // 将主险和副险分离，便于列表展示使用
            (data.risks || []).forEach((v) => {
                const mRiskInfo = initMRisk.find(t => t.code === v.code);
                if (mRiskInfo) {
                    mRisk.push({
                        ...v,
                        field: mRiskInfo.field,
                    });
                } else {
                    const sRiskInfo = initSRisk.find(t => t.code === v.code) || {};
                    sRisk.push({
                        ...v,
                        field: sRiskInfo.field,
                    });
                }
            });
            (oldInfo || []).forEach((item, index) => {
                if (item.baseInfo.companyId === data.baseInfo.companyId) {
                    oldInfo[index] = {
                        ...data,
                        code,
                        msg,
                        mRisk,
                        sRisk,
                    };
                }
            });
            state.quoteTableLists = oldInfo;
        },
        RELOAD_QUOTE_LIST: (state, data) => {
            let oldInfo = [...state.quoteTableLists];
            if (data) {
                const { companyId, reloadInfo } = data || {};
                oldInfo.forEach((item, index) => {
                    if (item.baseInfo.companyId === companyId) {
                        oldInfo[index] = {
                            ...item,
                            ...reloadInfo,
                        };
                    }
                });
            } else {
                oldInfo = oldInfo.map(item => ({
                    ...item,
                    reload: true,
                }));
            }
            state.quoteTableLists = oldInfo;
        },
        SAVE_QUOTE_PARAMS: (state, data) => {
            data.forEach((item) => {
                const { companyId } = item.baseInfo;
                state.quoteParams[companyId] = { ...item };
            });
        },
        CHANGE_QUOTE_PARAMS: (state, data) => {
            state.quoteParams[data.key] = { ...data.params };
        },
        SAVE_DEFAULT_RISK: (state, data) => {
            const res = {
                mRisk: [], // 主险
                sRisk: [], // 副险
            };
            data.forEach((item) => {
                if (item.sdew === 1) { // 主险
                    res.mRisk.push(item);
                } else { // 副险
                    res.sRisk.push(item);
                }
            });
            state.riskInfo = data;
            state.defaultRisk = res;
        },
        SAVE_RISK_CONFIG: (state, data) => {
            state.riskInfo = data;
            state.riskConfig = {
                mRisk: data.filter(item => item.sdew === 1),
                sRisk: data.filter(item => item.sdew !== 1),
            };
        },
        SAVE_QUOTED_INFO: (state, data) => {
            state.quotedInfo = data;
        },
        SET_ENUMS: (state, data) => {
            state.insuranceEnums = data;
        },
        SAVE_INSURANCE_ORDER: (state, data) => {
            state.insuranceOrder = data;
        },
        SAVE_INSURANCE_IMAGES: (state, data) => {
            state.insuranceImages = data;
        },
    },
    actions: {
        setInsuranceInfo({ commit }, data) {
            commit('INSURANCE_INFO', data);
        },
        saveQuoteList({ commit }, data) {
            commit('SAVE_QUOTE_LIST', data);
        },
        saveQuoteParams({ commit }, data) {
            commit('SAVE_QUOTE_PARAMS', data);
        },
        changeQuoteParams({ commit }, data) {
            commit('CHANGE_QUOTE_PARAMS', data);
        },
        changeQuoteInfo({ commit }, data) {
            commit('CHANGE_QUOTE_INFO', data);
        },
        saveDefaultRisk({ commit }, data) {
            commit('SAVE_DEFAULT_RISK', data);
        },
        saveRiskConfig({ commit }, data) {
            commit('SAVE_RISK_CONFIG', data);
        },
        saveQuotedInfo({ commit }, data) {
            commit('SAVE_QUOTED_INFO', data);
        },
        saveInsuranceOrder({ commit }, data) {
            commit('SAVE_INSURANCE_ORDER', data);
        },
        saveInsuranceImages({ commit }, data) {
            commit('SAVE_INSURANCE_IMAGES', data);
        },
        reloadQuoteList({ commit }, data) {
            commit('RELOAD_QUOTE_LIST', data);
        },
        // 获取车险信息相关enums
        async setEnums({ commit }) {
            // 通过获取enums值处理返回详情中返回key，显示对于label问题
            try {
                const enums = {};
                const { data } = await vehicleInsuranceApis.getInsuranceEnums();
                Object.keys(data || []).forEach((v) => {
                    enums[v] = data[v].map(item => ({
                        ...item,
                        label: item.desc,
                        value: item.name,
                    }));
                });
                this.enums = enums;
                commit('SET_ENUMS', enums);
            } catch (err) {
                throw new Error(err);
            } finally {
                this.loading = false;
            }
        },
    },
};

export default clues;
